/*
--- Total Portfolio = 22
*/

module.exports = [
  {
    title: "Injective Products",
    description:
      "Injective stands as one of the top blockchain (layer1) platforms globally around the world, ranked highly on CoinMarketCap and sets the standard for innovation in decentralized finance. It offers lightning-fast, scalable infrastructure for building DeFi applications and trading solutions. With a mission to empower users and decentralize global markets, Injective is shaping the future of financial technology. Have a look on the snapshots with the URLs!",
    thumbnail: require("@/assets/images/works/injective-1.webp"),
    thumbnailPosTop: true,
    year: 2025,
    tags: ["Web3", "Nuxt3"],
    website: "https://injective.com/",
    previews: [
      require("@/assets/images/works/injective-1.webp"),
      require("@/assets/images/works/injective-2.webp"),
      require("@/assets/images/works/injective-3.webp"),
      require("@/assets/images/works/injective-4.webp"),
      require("@/assets/images/works/injective-5.webp"),
      require("@/assets/images/works/injective-6.webp"),
      require("@/assets/images/works/injective-7.webp"),
      require("@/assets/images/works/injective-8.webp"),
      require("@/assets/images/works/injective-9.webp"),
    ],
    skills: [
      "Vue3",
      "Nuxt3",
      "Typescript",
      "Web3",
      "Blockchain/CosmosSDK",
      "Javascript",
      "NuxtUI",
      "TailwindCSS",
      "Pinia",
      "SCSS/SASS",
      "Github",
      "Jira",
    ],
  },
  {
    title: "Imaginary Ones NFT Products",
    description:
      "One of the most well-known NFT Brand with over 1.1M twitter followers, backed by dozens of VC/Investors, partnered with global brands (HUGO BOSS, Samsung, Transformer, and others), generated over 20k+ ETH opensea volume per 2024. Filled with stunning & interactive websites as part of IO ecosystem built on Web3, Nuxt3 & Vue3. Have a look on the snapshots with the URLs!",
    thumbnail: require("@/assets/images/works/io-1.jpg"),
    thumbnailPosTop: true,
    year: 2024,
    tags: ["Web3", "Vue3"],
    website: "https://imaginaryones.com/",
    previews: [
      require("@/assets/images/works/io-1.jpg"),
      require("@/assets/images/works/io-2.png"),
      require("@/assets/images/works/io-3.jpg"),
      require("@/assets/images/works/io-4.jpg"),
      require("@/assets/images/works/io-5.jpg"),
      require("@/assets/images/works/io-6.png"),
      require("@/assets/images/works/io-7.jpg"),
      require("@/assets/images/works/io-8.png"),
      require("@/assets/images/works/io-9.jpg"),
      require("@/assets/images/works/io-10.png"),
    ],
    skills: [
      "Vue3",
      "Nuxt3",
      "Vite",
      "Pinia",
      "Javascript",
      "Web3",
      "Viem",
      "Ethers.js",
      "Hardhat",
      "Smart Contract (Solidity)",
      "Ganache",
      "Alchemy",
      "OpenZeppelin",
      "Remix IDE",
      "Unit Testing (Mocha-Chai)",
      "Bitbucket",
      "Github",
      "Vuetify",
      "GSAP",
      "Metamask",
      "MySQL",
      "Nest.js",
      "Node.js",
      "Typescript",
      "Webpack",
      "Babel",
      "ESLint",
      "HTML",
      "SCSS/SASS",
    ],
  },
  {
    title: "OFFEO Singapore",
    description:
      "OFFEO is a design-driven video/image maker (similar to Canva) with over 300k users + 4 million visits of monthly traffic at June 2022. A solution to create marketing videos easily.",
    thumbnail: require("@/assets/images/works/offeo-1.jpg"),
    thumbnailPosTop: true,
    year: 2024,
    tags: ["Nuxt3", "Vue3"],
    website: "https://offeo.com/",
    previews: [
      require("@/assets/images/works/offeo-1.jpg"),
      require("@/assets/images/works/offeo-2.png"),
      require("@/assets/images/works/offeo-3.png"),
      require("@/assets/images/works/offeo-4.png"),
      require("@/assets/images/works/offeo-5.png"),
      require("@/assets/images/works/offeo-6.png"),
      require("@/assets/images/works/offeo-7.png"),
      require("@/assets/images/works/offeo-8.png"),
      require("@/assets/images/works/offeo-9.png"),
      require("@/assets/images/works/offeo-10.png"),
    ],
    skills: [
      "Vue.js",
      "Vue3",
      "Nuxt.js",
      "Nuxt3",
      "Vuex",
      "Pinia",
      "Javascript",
      "Unit Testing (Jest/Mocha-Chai)",
      "SEO & Web Performance",
      "Git (Bitbucket & Github)",
      "Storybook",
      "GSAP",
      "Vuetify",
      "Inertia.js",
      "Laravel",
      "PHP",
      "MySQL",
      "Webpack",
      "Babel",
      "BrowserStack",
      "HTML",
      "SCSS/SASS",
      "Linux",
    ],
  },
  {
    title: "Asia-Property",
    description:
      "Beautiful & modern real estate website that is developed with full-stack development (React.js, Redux & Express.js) from first designing phase until last deployment phase based on ideas received from themeforest.com & dribbble.com, styled purely with CSS.",
    thumbnail: require("@/assets/images/works/asia01.png"),
    year: 2021,
    tags: ["React.js", "Fullstack"],
    website: "https://asiaproperty.netlify.app/",
    previews: [
      require("@/assets/images/works/asia01.png"),
      require("@/assets/images/works/asia02.png"),
      require("@/assets/images/works/asia03.png"),
      require("@/assets/images/works/asia04.png"),
      require("@/assets/images/works/asia05.png"),
      require("@/assets/images/works/asia06.png"),
      require("@/assets/images/works/asia07.png"),
      require("@/assets/images/works/asia08.png"),
    ],
    skills: [
      "React.js",
      "ReactRedux",
      "Express.js",
      "MongoDB",
      "Cookie",
      "Heroku",
      "Vercel",
      "REST API",
      "SCSS",
      "Fullstack web development",
      "Icomoon",
      "Github",
    ],
  },
  {
    title: "Asia-Property (Admin Site)",
    description:
      "An excellent & convenient admin site developed within fullstack development. Inspired by admin website ideas from dribbble.com, created flawless interface that brings good experience to users.",
    thumbnail: require("@/assets/images/works/asia-admin01.png"),
    thumbnailPosTop: true,
    year: 2022,
    tags: ["React.js", "Fullstack"],
    website: "https://asiaproperty.netlify.app/admin?is_visitor=true",
    previews: [
      require("@/assets/images/works/asia-admin01.png"),
      require("@/assets/images/works/asia-admin02.png"),
      require("@/assets/images/works/asia-admin03.png"),
      require("@/assets/images/works/asia-admin04.png"),
      require("@/assets/images/works/asia-admin05.png"),
      require("@/assets/images/works/asia-admin06.png"),
      require("@/assets/images/works/asia-admin07.png"),
      require("@/assets/images/works/asia-admin08.png"),
      require("@/assets/images/works/asia-admin09.png"),
      require("@/assets/images/works/asia-admin10.png"),
      require("@/assets/images/works/asia-admin11.png"),
      require("@/assets/images/works/asia-admin12.png"),
    ],
    skills: [
      "React.js",
      "ReactRedux",
      "Express.js",
      "MongoDB",
      "Cookie",
      "Heroku",
      "Vercel",
      "REST API",
      "SCSS",
      "Fullstack Web Development",
      "Apexchart.js",
      "Icomoon",
      "Github",
    ],
  },
  {
    title: "GlobalUI Components Library",
    description:
      "A UI Components Library that is created with Vue.js, so i created the base and setups for each component, then later on developers can just simply import and use it with my code and settings working in the background ( similar to bootstrap, materialUI, vuetify, etc ). Support the usage for Vue.js or Nuxt.js developers. A system example for agencies that want to have consistent UI. Also have UI documentation created with Storybook.js. Deployed as a NPM package to be an opensource package installable for any developers around the world.",
    thumbnail: require("@/assets/images/works/css-framework5.png"),
    year: 2021,
    tags: ["Vue.js", "NPM"],
    website: "https://global-ui-docs.netlify.app/",
    npmWebsite: "https://www.npmjs.com/package/global-ui",
    previews: [
      require("@/assets/images/works/css-framework1.png"),
      require("@/assets/images/works/css-framework2.png"),
      require("@/assets/images/works/css-framework3.png"),
      require("@/assets/images/works/css-framework4.png"),
      require("@/assets/images/works/css-framework5.png"),
    ],
    skills: [
      "Vue.js",
      "Storybook",
      "NPM",
      "NPM Package Deployment",
      "Component Documentation System",
      "Component Library System",
      "Animation Loader System",
      "Icomoon",
      "SCSS",
      "Github",
    ],
  },
  {
    title: "Tian San Shipping (TSS) Singapore",
    description:
      "Stunning Nuxt.js Website Built for Singapore Tian San Shipping Company (https://www.tiansan.com.sg/). Has mailing system that able to send attachments and able to send to gmail. Accessible within any device and screen from 320px to larger than 2560px. Hide SEO settings and other privacy informations in this website for partner privacy.",
    thumbnail: require("@/assets/images/works/tss-1.jpg"),
    year: 2022,
    tags: ["Nuxt.js", "Responsive Web App"],
    website: "https://non-official-tss.netlify.app/",
    previews: [
      require("@/assets/images/works/tss-1.jpg"),
      require("@/assets/images/works/tss-2.jpg"),
      require("@/assets/images/works/tss-3.jpg"),
      require("@/assets/images/works/tss-4.jpg"),
      require("@/assets/images/works/tss-5.jpg"),
      require("@/assets/images/works/tss-6.jpg"),
      require("@/assets/images/works/tss-7.jpg"),
      require("@/assets/images/works/tss-8.jpg"),
      require("@/assets/images/works/tss-9.jpg"),
      require("@/assets/images/works/tss-10.jpg"),
      require("@/assets/images/works/tss-11.jpg"),
      require("@/assets/images/works/tss-12.jpg"),
    ],
    skills: [
      "Nuxt.js",
      "Vue.js",
      "Vuex",
      "Mailing System",
      "Responsive Web App",
      "SEO",
      "Webpack",
      "SCSS",
      "Github",
      "Icomoon",
    ],
  },
  {
    title: "NIEWS Singapore",
    description:
      "Stunning Website Built for Singapore National Institute of Education & Singapore Nanyang Technological University for Their #120 Campaign (https://niews.nie.edu.sg/jun2022/). Accessible within any device and screen from 320px to larger than 2560px. Hide SEO settings and other privacy informations for partner privacy.",
    thumbnail: require("@/assets/images/works/niews-1.jpg"),
    year: 2022,
    tags: ["Nuxt.js", "Responsive Web App"],
    website: "https://non-official-niews-nuxt.netlify.app/",
    previews: [
      require("@/assets/images/works/niews-1.jpg"),
      require("@/assets/images/works/niews-2.jpeg"),
      require("@/assets/images/works/niews-3.jpeg"),
      require("@/assets/images/works/niews-4.jpeg"),
      require("@/assets/images/works/niews-5.jpeg"),
      require("@/assets/images/works/niews-6.jpeg"),
      require("@/assets/images/works/niews-7.jpeg"),
      require("@/assets/images/works/niews-8.jpeg"),
    ],
    skills: [
      "Nuxt.js",
      "Vue.js",
      "Vuex",
      "Responsive Web App",
      "SEO",
      "Webpack",
      "SCSS",
      "Github",
      "Icomoon",
    ],
  },
  {
    title: "ChenFrederick.com (Personal Web)",
    description:
      "Amazing responsive personal website with dark mode feature & web animations. Accessible within any device and screen from 320px to larger than 2560px. Sharing more about my capabilities, experience & skills. This web has staging site and production site system (the one you're accessing now). All components, features & stylings here were made purely without help from any CSS framework. Let's get to know each other.",
    thumbnail: require("@/assets/images/works/personal-web-responsive.jpg"),
    thumbnailPosTop: true,
    year: 2021,
    tags: ["Vue.js", "Responsive Web App"],
    website: "https://staging.chenfrederick.com/",
    previews: [
      require("@/assets/images/works/personal-web02.png"),
      require("@/assets/images/works/personal-web01.png"),
      require("@/assets/images/works/personal-web-responsive.jpg"),
      require("@/assets/images/works/personal-web03.png"),
      require("@/assets/images/works/personal-web04.png"),
      require("@/assets/images/works/personal-web05.png"),
      require("@/assets/images/works/personal-web06.png"),
      require("@/assets/images/works/personal-web07.png"),
      require("@/assets/images/works/personal-web08.png"),
      require("@/assets/images/works/personal-web09.jpeg"),
    ],
    skills: [
      "Vue.js",
      "Vuex",
      "Dark Mode",
      "Responsive Web App",
      "Animation Loader System",
      "Website Domain Handling & Deployment",
      "Staging & Production Site System",
      "Cloudflare",
      "Webpack",
      "SCSS",
      "Github",
      "Icomoon",
    ],
  },
  {
    title: "AWS Tutorials",
    description:
      "Created Youtube Videos about AWS Deployments and Uses - With Lots of Tech Stack Inside (Vue, Nuxt, React, Express, S3, RDS, Security Group, Elastic IP, MySQL, etc)",
    thumbnail: require("@/assets/images/works/aws-1.png"),
    year: 2023,
    tags: ["AWS", "Devops"],
    youtube: "https://www.youtube.com/@frederick88/videos",
    previews: [
      require("@/assets/images/works/aws-1.png"),
      require("@/assets/images/works/aws-2.png"),
    ],
    skills: ["AWS", "Devops", "AWS EC2", "AWS RDS", "AWS S3"],
  },
  {
    title: "Xeno - React Landing Page",
    description:
      "Beautiful responsive React.js website that is accessible within any device and screen from 320px to larger than 2560px.",
    thumbnail: require("@/assets/images/works/xeno-1.jpg"),
    thumbnailPosTop: true,
    year: 2023,
    tags: ["React.js", "Responsive Web App"],
    website: "https://xeno-app.netlify.app/",
    previews: [
      require("@/assets/images/works/xeno-1.jpg"),
      require("@/assets/images/works/xeno-2.jpg"),
      require("@/assets/images/works/xeno-3.jpg"),
      require("@/assets/images/works/xeno-4.jpg"),
      require("@/assets/images/works/xeno-5.jpg"),
      require("@/assets/images/works/xeno-6.jpg"),
    ],
    skills: ["React.js", "Responsive Web App", "SCSS", "Github"],
  },
  {
    title: "Elite Web House - Web Agency",
    description:
      "A modern web agency website built on wordpress that is accessible within any device and screen from 320px to larger than 2560px.",
    thumbnail: require("@/assets/images/works/ewh-1.jpg"),
    thumbnailPosTop: true,
    year: 2023,
    tags: ["Wordpress", "Responsive Web App"],
    website: "https://elitewebhouse.com/",
    previews: [
      require("@/assets/images/works/ewh-1.jpg"),
      require("@/assets/images/works/ewh-2.png"),
      require("@/assets/images/works/ewh-3.png"),
      require("@/assets/images/works/ewh-4.png"),
      require("@/assets/images/works/ewh-5.png"),
      require("@/assets/images/works/ewh-6.png"),
      require("@/assets/images/works/ewh-7.png"),
    ],
    skills: ["Wordpress", "Responsive Web App", "CSS", "SEO"],
  },
  {
    title: "S2 Boutique E-Commerce",
    description:
      "Full Version of React.js & Redux E-Commerce made with Fullstack Development (Frontend, Backend until Deployments), Inspiration based on Best Seller E-Commerce app in themeforest (PickBazar). When user register & data stored to database, CRUD products of admin, and everything that runs here was made by me. Check out this cool E-commerce!",
    thumbnail: require("@/assets/images/works/react-ecommerce1.png"),
    year: 2020,
    tags: ["React.js", "Fullstack"],
    website: "https://s2-boutique.netlify.app/",
    previews: [
      require("@/assets/images/works/react-ecommerce1.png"),
      require("@/assets/images/works/react-ecommerce2.png"),
      require("@/assets/images/works/react-ecommerce3.png"),
      require("@/assets/images/works/react-ecommerce4.png"),
      require("@/assets/images/works/react-ecommerce5.png"),
    ],
    skills: [
      "React.js",
      "React Redux",
      "Express.js",
      "MongoDB",
      "Heroku",
      "Vercel",
      "AWS",
      "REST API",
      "Fullstack Web Development",
      "SCSS",
      "Github",
    ],
  },
  {
    title: "Weatherpedia (PWA)",
    description:
      "Weatherpedia provides weather informations in Singapore ( by default ) and show current weather with attractive & different designs, made with PWA development-model ( Progressive Web App ). With this, user can download the whole web to their tablets/phones for a very small size of 332 kb. then user also can search other country/city to seek their weather information at here. Supported by API from https://api.openweathermap.org",
    thumbnail: require("@/assets/images/works/weatherpedia-pwa1.jpg"),
    year: 2021,
    tags: ["React.js", "PWA"],
    website: "https://weatherpedia.netlify.app/",
    previews: [
      require("@/assets/images/works/weatherpedia-pwa1.jpg"),
      require("@/assets/images/works/weatherpedia-pwa2.jpg"),
      require("@/assets/images/works/weatherpedia-pwa3.png"),
      require("@/assets/images/works/weatherpedia-pwa4.jpeg"),
      require("@/assets/images/works/weatherpedia-pwa5.jpeg"),
      require("@/assets/images/works/weatherpedia-pwa6.jpg"),
      require("@/assets/images/works/weatherpedia-pwa7.jpg"),
      require("@/assets/images/works/weatherpedia-pwa8.jpg"),
      require("@/assets/images/works/weatherpedia-pwa9.jpg"),
      require("@/assets/images/works/weatherpedia-pwa10.jpg"),
    ],
    skills: [
      "React.js",
      "Progressive Web App (PWA)",
      "REST API",
      "Responsive Web App",
      "SCSS",
      "Github",
    ],
  },
  {
    title: "Sma Mw Library Profile + Admin CMS Site",
    description:
      "A Vue.js - Vuex (Frontend Side) + Firebase (Backend Side) responsive library profile website with admin content management system (CMS) that is created for one of the most well-known high school at Batam, Indonesia. Accessible within any device and screen from 320px to larger than 2560px. Used Vuetify as plugin for styling purposes with Firebase hosting and database system integrated to Vue.js and Vuex frontend side. Together, as a fullstack website app.",
    thumbnail: require("@/assets/images/works/smw-library-responsive.jpg"),
    thumbnailPosTop: true,
    year: 2022,
    tags: ["Vue.js", "Firebase"],
    website: "https://sma-mw-library.web.app/",
    previews: [
      require("@/assets/images/works/smw-library01.jpg"),
      require("@/assets/images/works/smw-library02.jpg"),
      require("@/assets/images/works/smw-library-responsive.jpg"),
      require("@/assets/images/works/smw-library03.jpg"),
      require("@/assets/images/works/smw-library04.jpg"),
      require("@/assets/images/works/smw-library05.jpg"),
      require("@/assets/images/works/smw-library06.jpg"),
      require("@/assets/images/works/smw-library07.jpg"),
      require("@/assets/images/works/smw-library08.jpg"),
      require("@/assets/images/works/smw-library09.jpg"),
      require("@/assets/images/works/smw-library10.jpg"),
      require("@/assets/images/works/smw-library11.jpg"),
    ],
    skills: [
      "Vue.js",
      "Firebase",
      "Vuex",
      "Responsive Web App",
      "Vuetify",
      "Fullstack Web Development",
      "Cookie",
      "SCSS",
      "Github",
    ],
  },
  {
    title: "Web Performance & SEO Improvements Studycase",
    description:
      "Web performance & SEO improvements done on my personal website (chenfrederick.com). Can see the snapshots for before-after of the web performance result inspected with Lighthouse & SEO result where my website exist in page 1 at google search result.",
    thumbnail: require("@/assets/images/works/web-performance-after.jpeg"),
    year: 2021,
    tags: ["SEO", "Web Performance"],
    website: "https://www.chenfrederick.com/",
    previews: [
      require("@/assets/images/works/web-performance-before.png"),
      require("@/assets/images/works/web-performance-after.jpeg"),
      require("@/assets/images/works/seo-result1.png"),
      require("@/assets/images/works/seo-result2.png"),
      require("@/assets/images/works/personal-web09.jpeg"),
    ],
    skills: [
      "Web Performance",
      "Web Optimization",
      "SEO",
      "Vue.js",
      "Lighthouse Inspection",
    ],
  },
  {
    title: "Northstar Analytics - Vue 3.0",
    description:
      "Stunning & interactive responsive Vue 3.0 website that is accessible within any device and screen from 320px to larger than 2560px.",
    thumbnail: require("@/assets/images/works/northstar-1.jpg"),
    thumbnailPosTop: true,
    year: 2023,
    tags: ["Vue3", "Responsive Web App"],
    website: "https://northstar-analytics-vue3.netlify.app/",
    previews: [
      require("@/assets/images/works/northstar-1.jpg"),
      require("@/assets/images/works/northstar-2.jpg"),
      require("@/assets/images/works/northstar-3.jpg"),
      require("@/assets/images/works/northstar-4.jpg"),
      require("@/assets/images/works/northstar-5.jpg"),
      require("@/assets/images/works/northstar-6.jpg"),
      require("@/assets/images/works/northstar-7.jpg"),
      require("@/assets/images/works/northstar-8.jpg"),
      require("@/assets/images/works/northstar-9.jpg"),
    ],
    skills: [
      "Vue3",
      "Vue.js",
      "Pinia",
      "Vite",
      "Responsive Web App",
      "SCSS",
      "Github",
      "Icomoon",
    ],
  },
  {
    title: "Laravel Fullstack Community Website",
    description:
      "An Interactive Fullstack Laravel Color Palette Community Website Made with MySQL, Laravel Blade, Laravel & Tailwind.css. Integrated with gmail mailing system & deployed to heroku included database.",
    thumbnail: require("@/assets/images/works/laravel-fullstack-app2.png"),
    year: 2021,
    tags: ["Laravel-PHP", "Fullstack"],
    website: null,
    github: "https://github.com/Frederick-88/laravel-fullstack-app",
    previews: [
      require("@/assets/images/works/laravel-fullstack-app1.png"),
      require("@/assets/images/works/laravel-fullstack-app2.png"),
      require("@/assets/images/works/laravel-fullstack-app3.png"),
      require("@/assets/images/works/laravel-fullstack-app4.png"),
      require("@/assets/images/works/laravel-fullstack-app5.png"),
      require("@/assets/images/works/laravel-fullstack-app6.png"),
      require("@/assets/images/works/laravel-fullstack-app7.png"),
      require("@/assets/images/works/laravel-fullstack-app8.png"),
      require("@/assets/images/works/laravel-fullstack-app9.png"),
    ],
    skills: [
      "Laravel & PHP",
      "MYSQL",
      "Laravel Blade",
      "Tailwind.css",
      "Gmail Mailing System",
      "Heroku Deployment",
      "Fullstack Web Development",
    ],
  },
  {
    title: "Zeno - React Landing Page",
    description:
      "Modern responsive React.js website that is accessible within any device and screen from 320px to larger than 2560px.",
    thumbnail: require("@/assets/images/works/zeno-1.jpg"),
    thumbnailPosTop: true,
    year: 2023,
    tags: ["React.js", "Responsive Web App"],
    website: "https://zeno-app.netlify.app/",
    previews: [
      require("@/assets/images/works/zeno-1.jpg"),
      require("@/assets/images/works/zeno-2.jpg"),
      require("@/assets/images/works/zeno-3.jpg"),
      require("@/assets/images/works/zeno-4.jpg"),
      require("@/assets/images/works/zeno-5.jpg"),
      require("@/assets/images/works/zeno-6.jpg"),
    ],
    skills: ["React.js", "Responsive Web App", "SCSS", "Github"],
  },
  {
    title: "Web 3.0 - Crypto Wallet Interaction Website",
    description:
      "A Vue3 & Web3 website that demonstrate crypto wallet usage ( metamask, etc ). Currently able to test in testnet environment, which can use Goerli test network. Able to connect wallet, sign wallet, get wallet balance and get NFTs list.",
    thumbnail: require("@/assets/images/works/vue3-web3-2.jpg"),
    thumbnailPosTop: true,
    year: 2023,
    tags: ["Web3", "Vue3"],
    website: "https://vue3-web3.netlify.app/",
    previews: [
      require("@/assets/images/works/vue3-web3-1.jpg"),
      require("@/assets/images/works/vue3-web3-2.jpg"),
      require("@/assets/images/works/vue3-web3-3.jpg"),
      require("@/assets/images/works/vue3-web3-4.jpg"),
      require("@/assets/images/works/vue3-web3-5.jpg"),
      require("@/assets/images/works/vue3-web3-6.jpg"),
    ],
    skills: [
      "Vue3",
      "Vue.js",
      "Pinia",
      "Vite",
      "Responsive Web App",
      "SCSS",
      "Github",
      "Icomoon",
    ],
  },
  {
    title: "Technical Test - Photo Album Website",
    description:
      'A Sample Technical Test (Real-Life) of React.js (Responsive Web App) to Fetch API from an Opensource API - "https://jsonplaceholder.typicode.com".',
    thumbnail: require("@/assets/images/works/photo-album-test-01.png"),
    year: 2021,
    tags: ["React.js", "Responsive Web App"],
    website: "https://fd-photoalbum.netlify.app/",
    github: "https://github.com/Frederick-88/sample-react-technical-test",
    previews: [
      require("@/assets/images/works/photo-album-test-01.png"),
      require("@/assets/images/works/photo-album-test-02.png"),
      require("@/assets/images/works/photo-album-test-03.png"),
      require("@/assets/images/works/photo-album-test-04.png"),
      require("@/assets/images/works/photo-album-test-05.png"),
    ],
    skills: ["React.js", "Responsive Web App", "REST API", "SCSS", "Github"],
  },
  {
    title: "Pair Programming Test - PokeAPI",
    description:
      'A Sample Pair Programming Test (Real-Life) of React.js to Fetch API from an Opensource API - "https://pokeapi.co/". With the duration of 30 minutes to create then stop the development.',
    thumbnail: require("@/assets/images/works/pair-programming-test-01.png"),
    year: 2021,
    tags: ["React.js", "REST API"],
    website: "https://pokeapi-test.netlify.app/",
    previews: [require("@/assets/images/works/pair-programming-test-01.png")],
    skills: ["React.js", "REST API", "SCSS", "Github"],
  },
  {
    title: "Vue Text to Speech AI",
    description:
      "An AI created on Vue web application about text to speech convertion. It's accessible on any screen size since its a responsive web app which also has playback speed and gender voice options for users to use around.",
    thumbnail: require("@/assets/images/works/vue-text-to-speech.png"),
    year: 2022,
    tags: ["Vue.js", "Responsive Web App"],
    website: "https://vue-text-to-speech.netlify.app/",
    previews: [require("@/assets/images/works/vue-text-to-speech.png")],
    skills: ["Vue.js", "AI", "SCSS", "Responsive Web App"],
  },
  {
    title: "EF SET International English Score (CEFR)",
    description:
      "International English Score (76/100) on the EF SET score scale and C2 Proficient according to the Common European Framework of Reference (CEFR).",
    thumbnail: require("@/assets/images/works/efset-score02.jpg"),
    thumbnailPosTop: true,
    year: 2022,
    tags: ["English"],
    website: "https://www.efset.org/cert/n5eDJi",
    previews: [
      require("@/assets/images/works/efset-score01.jpg"),
      require("@/assets/images/works/efset-score02.jpg"),
    ],
    skills: ["English", "Communication"],
  },
  {
    title: "PHP + MYSQL - Payroll Website",
    description:
      "A Pure PHP & MYSQL Fullstack payroll website. Able to handle authentication, pdf exports, database connections, and many things across users activity on the web.",
    thumbnail: require("@/assets/images/works/payroll01.jpeg"),
    year: 2020,
    tags: ["PHP-MYSQL", "Fullstack"],
    website: null,
    github: "https://github.com/Frederick-88/PHP-SQL-PAYROLL-WEB",
    previews: [
      require("@/assets/images/works/payroll01.jpeg"),
      require("@/assets/images/works/payroll02.jpeg"),
      require("@/assets/images/works/payroll03.jpeg"),
      require("@/assets/images/works/payroll04.jpeg"),
      require("@/assets/images/works/payroll05.jpeg"),
      require("@/assets/images/works/payroll06.jpeg"),
      require("@/assets/images/works/payroll07.jpeg"),
      require("@/assets/images/works/payroll08.jpeg"),
      require("@/assets/images/works/payroll09.jpeg"),
    ],
    skills: [
      "PHP",
      "MYSQL",
      "Bootstrap",
      "Fullstack Web Development",
      "CSS",
      "PDF Export System",
    ],
  },
  {
    title: "SmartLocal Gists Page",
    description:
      "This is 1 of the test from a company based on Singapore. With a github opensource api given (https://api.github.com/gists/public),then creatively display it to users. Here, user can see any topic of github gists, search based on github usernames, favourite gists, look through gists author, etc.",
    thumbnail: require("@/assets/images/works/smartlocal1.png"),
    year: 2020,
    tags: ["React.js", "REST API"],
    website: "https://github-gists.netlify.app/",
    previews: [
      require("@/assets/images/works/smartlocal1.png"),
      require("@/assets/images/works/smartlocal2.png"),
      require("@/assets/images/works/smartlocal3.png"),
      require("@/assets/images/works/smartlocal4.png"),
    ],
    skills: [
      "React.js",
      "Local Storage",
      "REST API",
      "Font Awesome",
      "React Toastify",
      "SCSS",
      "Github",
    ],
  },
  {
    title: "FD-Technologies (Personal Web)",
    description:
      "My previous personal web created with React.js & Bootstrap. Accessible with any device since its a responsive web app.",
    thumbnail: require("@/assets/images/works/fdtech01.png"),
    year: 2020,
    tags: ["React.js", "Responsive Web App"],
    website: "https://fd-tech.netlify.app/",
    previews: [
      require("@/assets/images/works/fdtech01.png"),
      require("@/assets/images/works/fdtech02.png"),
      require("@/assets/images/works/fdtech03.png"),
      require("@/assets/images/works/fdtech04.png"),
    ],
    skills: [
      "React.js",
      "Responsive Web App",
      "SCSS",
      "Website Domain Handling & Deployment",
      "Cloudflare",
      "Bootstrap",
      "FontAwesome",
      "Github",
    ],
  },
  {
    title: "React & Vue Unit Testing Sample Practices",
    description:
      "React & Vue Unit Testing Sample Practices (for react - https://github.com/Frederick-88/react-unit-testing) & (for vue - https://github.com/Frederick-88/vue-unit-testing)",
    thumbnail: require("@/assets/images/works/vue-react-unit-test.png"),
    year: 2021,
    tags: ["React.js", "Vue.js"],
    website: null,
    github:
      "https://github.com/Frederick-88?tab=repositories&q=unit&type=&language=&sort=",
    previews: [require("@/assets/images/works/vue-react-unit-test.png")],
    skills: ["Vue.js", "React.js", "Unit Testing"],
  },
  {
    title: "Circle Messenger",
    description:
      "A Real-Time messenger app which is a team final project in glints academy bootcamp. Here, users could send image, documents and even show expressions with emoji here!",
    thumbnail: require("@/assets/images/works/circle-messenger1.png"),
    year: 2020,
    tags: ["React.js", "Fullstack"],
    website: null,
    github: "https://github.com/Glints-x-IB-Chat-box",
    previews: [
      require("@/assets/images/works/circle-messenger1.png"),
      require("@/assets/images/works/circle-messenger2.png"),
    ],
    skills: [
      "React.js",
      "React Redux",
      "Socket.io",
      "Google Cloud",
      "REST API",
      "Express.js",
      "MongoDB",
      "Font Awesome",
      "SCSS",
      "Github",
    ],
  },
  {
    title: "Kos45 - No Bullying Community Web",
    description:
      "A Responsive Web App created with React.js about no bullying community.",
    thumbnail: require("@/assets/images/works/kos45-01.png"),
    year: 2020,
    tags: ["React.js", "Responsive Web App"],
    website: "https://kos45.netlify.app/#/",
    previews: [
      require("@/assets/images/works/kos45-01.png"),
      require("@/assets/images/works/kos45-02.png"),
      require("@/assets/images/works/kos45-03.png"),
    ],
    skills: ["React.js", "Responsive Web App", "FontAwesome", "SCSS", "Github"],
  },
];
